const RECENT_KEY = 'point_recent_entities';
const MAX_RECENT = 30;

function readAll() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(data));
  } catch { /* ignore quota */ }
}

export function trackRecentEntity(entity, entityId) {
  const id = Number(entityId);
  if (!id || id <= 0) return;
  const key = String(entity || 'cari').toLowerCase();
  const all = readAll();
  const list = Array.isArray(all[key]) ? all[key].filter((n) => Number(n) !== id) : [];
  list.unshift(id);
  all[key] = list.slice(0, MAX_RECENT);
  writeAll(all);
}

export function getRecentEntities(entity, limit = 20) {
  const key = String(entity || 'cari').toLowerCase();
  const all = readAll();
  const list = Array.isArray(all[key]) ? all[key] : [];
  return list.map(Number).filter((n) => n > 0).slice(0, limit);
}

export function removeRecentEntity(entity, entityId) {
  const id = Number(entityId);
  const key = String(entity || 'cari').toLowerCase();
  const all = readAll();
  all[key] = (Array.isArray(all[key]) ? all[key] : []).filter((n) => Number(n) !== id);
  writeAll(all);
}
